// import { v4 as uuidV4 } from 'uuid';
// import { mergeContentStates } from './editor-utils';
import { contentSkillTagParams } from './mastery-taxonomy-utils';

import conceptIcon from 'images/icons/chalkboard-teacher.svg';
import cheatsheetIcon from 'images/icons/cheat-sheet.svg';
import introIcon from 'images/icons/hand-wave.svg';
import theoryIcon from 'images/icons/light-bulb.svg';
import practiceIcon from 'images/icons/notes-green.svg';
import videoIcon from 'images/icons/video-blue.svg';

export function getLessonIcon(lesson = {}) {
  switch (lesson.type) {
    case 'practice_question':
      return practiceIcon;
    case 'concept_clarifier':
      return conceptIcon;
    case 'cheatsheet':
      return cheatsheetIcon;
    case 'intro':
      return introIcon;
  }
  if (!lesson.reading_only && lesson.video) {
    return videoIcon;
  }
  return theoryIcon;
}

// if a 'cloned' activity, will include all fetched attributes
// that we don't need to send
export function courseLessonToParams({
  base_type,
  content_preview,
  content_skill_tags,
  course_usage_stats,
  created_at,
  editor,
  editor_data_fetched,
  full_fetch,
  gid,
  has_video,
  relationships,
  updated_at,
  user,
  user_id,
  video,
  video_posters,
  video_thumbnails,
  ...lesson
}) {
  return {
    ...lesson,
    video_id: video && video.id,
    ...contentSkillTagParams(content_skill_tags),
  };
}

export const COURSE_LESSON_TYPES_CONFIG = {
  theory: {
    label: 'Theory',
    abbrv: 'Th',
  },
  concept_clarifier: {
    label: 'Example Problem',
    abbrv: 'Ex',
  },
  practice_question: {
    label: 'Practice Question',
    abbrv: 'PQ',
    disabled: true,
  },
  cheatsheet: {
    label: 'Cheatsheet',
    abbrv: 'CS',
  },
  intro: {
    label: 'Intro',
    abbrv: 'In',
  },
};

// export function quizQuestionToCourseLesson(quizQuestion) {
//   const lesson = { clientId: uuidV4(), type: 'concept_clarifier', base_type: 'CourseLesson' };
//   if (!quizQuestion) return lesson;
//
//   lesson.title = quizQuestion.description;
//   lesson.elements = quizQuestion.video_elements;
//   lesson.video = quizQuestion.video;
//   if (quizQuestion.id) {
//     lesson.synced_from_type = 'QuizQuestion';
//     lesson.synced_from_id = quizQuestion.id;
//     lesson.synced_at = new Date();
//   }
//   lesson.tag_list = quizQuestion.tag_list;
//   lesson.user_id = quizQuestion.user_id;
//
//   lesson.content = quizQuestionToLectureContent(quizQuestion);
//   return lesson;
// }
//
// function quizQuestionToLectureContent(quizQuestion) {
//   if (!quizQuestion) return;
//   const contentStates = [];
//   if (quizQuestion.type === 'FillInTheBlank') {
//     contentStates.push(quizQuestion.fitb_content);
//   } else {
//     contentStates.push(quizQuestion.content);
//   }
//   if (quizQuestion.type === 'MultipleChoice') {
//     (quizQuestion.options || []).forEach(opt => contentStates.push(opt.content));
//   }
//
//   if (quizQuestion.hint) contentStates.push(quizQuestion.hint);
//
//   if (quizQuestion.solution) {
//     (Array.isArray(quizQuestion.solution) ? quizQuestion.solution : [quizQuestion.solution]).forEach(solution => {
//       contentStates.push({
//         ...solution,
//         blocks: (solution.blocks || []).map(b => ({ ...b, data: { ...b.data, solution: true } }))
//       });
//     });
//   }
//   return mergeContentStates(contentStates);
// }
